import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DailyfactPageRoutingModule } from './dailyfact-routing.module';

import { DailyfactPage } from './dailyfact.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DailyfactPageRoutingModule
  ],
  declarations: [DailyfactPage]
})
export class DailyfactPageModule {}
